import {Prop, Element, Component, h, Host} from '@stencil/core'
import {NestButtonSize, NestButtonVariant} from "./nest-button.interfaces";

@Component({
  tag: 'nest-button',
  styleUrl: 'nest-button.scss',
  shadow: true,
})
export class NestButton {
  @Element() el!: HTMLButtonElement

  @Prop() type: 'submit' | 'button' = 'button'

  @Prop() variant: NestButtonVariant = 'primary';

  /**
   * Size of the button
   */
  @Prop() size: NestButtonSize = 'medium';

  /**
   * If `true`, the user cannot interact with the button.
   */
  @Prop({ reflect: true }) disabled = false

  /**
   * If `true` the label is hidden and a loading spinner is shown instead.
   */
  @Prop({ reflect: true }) isLoading = false

  /**
   * Name of the left button icon
   */
  @Prop() icon: string = null

  /**
   * Name of the right button icon
   */
  @Prop() iconEnd: string = undefined

  private handleClick = (): void => {}

  render() {
    const getIcon = (icon: string, size: NestButtonSize) => (
      <nest-icon name={icon} class={{
        'w-3 h-3': size === 'small',
        'w-5 h-5': size === 'medium',
        'w-6 h-6': size === 'large',
        'fill-white': this.variant === 'primary',
        'group-hover:fill-blue-600': this.variant === 'outline',
        'fill-blue-600 group-hover:fill-blue-800': this.variant === 'link',
      }}/>
    );

    const {variant, size, disabled, isLoading, icon, iconEnd} = this
    return (
      <Host>
        <button
          type="button"
          onClick={this.handleClick}
          class={{
            'nest-button group flex gap-1 items-center justify-center whitespace-nowrap rounded-md font-medium disabled:opacity-100 transition': true,
            'nest-button--primary': variant === 'primary',
            'nest-button--secondary': variant === 'secondary',
            'nest-button--outline': variant === 'outline',
            'nest-button--link': variant === 'link',
            'text-xs py-2 px-4': size === 'small',
            'text-[.9rem] py-2.5 px-6': size === 'medium',
            'text-sm py-3.5 px-7': size === 'large'
          }}
          aria-disabled={disabled || isLoading ? 'true' : null}
          disabled={disabled || isLoading}
        >
          {this.icon && getIcon(icon, size)}

          <slot></slot>

          {!isLoading && this.iconEnd && getIcon(iconEnd, size)}

          {isLoading && <nest-spinner/> }
        </button>
      </Host>
    )
  }
}
